// Iter221 · Constantes compartidas para Ofertas TIC (deben coincidir con
// backend/routers/offers.py::CONTRACT_TYPES).
export const CONTRACT_TYPES = [
  { code: "PYJ",   label: "Parques y Jardines" },
  { code: "LYR",   label: "Limpieza y Recogida" },
  { code: "LV",    label: "Limpieza Viaria" },
  { code: "RSU",   label: "Recogida de RSU" },
  { code: "SER",   label: "Movilidad" },
  { code: "OTROS", label: "Otros" },
];

export const CONTRACT_TYPE_LABEL = Object.fromEntries(
  CONTRACT_TYPES.map(t => [t.code, t.label])
);

export const contractTypeLabel = (code, other) => {
  if (!code) return "—";
  const upper = String(code).toUpperCase();
  if (upper === "OTROS") return other?.trim() ? `Otros · ${other.trim()}` : "Otros";
  return CONTRACT_TYPE_LABEL[upper] || code;
};
